<svg
  class="cogging-torque-compensation-graph"
  [class.enabled]="enabled"
  width="900"
  height="900"
  viewBox="0 0 900 900"
  style="max-width: 900px; width: 100%; height: auto"
>
  <g transform="translate(450, 450)"></g>
</svg>
